import React, { lazy, Suspense } from "react";
import strings from "@/lang/strings";
import { IconClass, IconClassFilled } from "@/components/icons/class";
import { IconDatalab, IconDatalabFill } from "@/components/icons/datalab";
import { IconStudy, IconStudyFilled } from "@/components/icons/study";
import { IconWallet, IconWalletFilled } from "@/components/icons/wallet";
import colors from "@/design/colors";

import BillConfirmPage from "@/pages/chewing-payments/confirm/BillConfirmPage";
import PaymentProcessPage from "@/pages/chewing-payments/precess/PaymentProcessPage";
import PaymentPendingPage from "@/pages/chewing-payments/pending/PaymentPendingPage";
import PaymentResultPage from "@/pages/chewing-payments/result/PaymentResultPage";
import PaymentFailPage from "@/pages/chewing-payments/error/PaymentFailPage";

import PayTestPage from "@/pages/chewing-payments/test/PayTestPage";
import PayTestResultPage from "@/pages/chewing-payments/test/PayTestResultPage";
import PayTestCancelPage from "@/pages/chewing-payments/test/PayTestCancelPage";
import payTestCancelCari from "@/pages/chewing-payments/test/PayTestCancelCariPage";
import PayTestPageDirect from "@/pages/chewing-payments/test/PayTestPageDirect";
import PayTestSearchPage from "@/pages/chewing-payments/test/PayTestSearchPage";



// Lazy-loaded pages

// Suspense wrapper
const withSuspense = (Component) => () =>
  (
    <Suspense fallback={null}>
      <Component />
    </Suspense>
  );

// 메뉴 타입 정의
export interface IMenu {
  path: string; // 메뉴 그룹 경로
  title: string; // 메뉴 제목
  iconActive: React.ReactNode; // 활성 아이콘
  iconInactive: React.ReactNode; // 비활성 아이콘
  user_type?: string; // 특정 유저 타입 한정
  children: {
    path: string;
    title: string;
    exact?: boolean;
    private?: boolean; // 인증 필요 여부
    component: () => React.ReactNode; // 렌더링할 컴포넌트
    user_type?: string;
    containPath?: string[]; // 경로 매칭용
  }[];
}

// 단일 라우트 타입 정의 (사이드바 메뉴에 안 보이는 라우트용)
export interface ISubMenu {
  path: string; // 라우트 경로
  title: string; // 라우트 제목
  exact?: boolean; // 정확한 경로 매칭 여부
  private?: boolean; // 인증 필요 여부
  component: () => React.ReactNode; // 렌더링할 컴포넌트
  user_type?: string; // 특정 유저 타입 한정
  containPath?: string[]; // 경로 매칭용
}

// ClassExtra: 학생/기관용 로그인·회원가입 등 메뉴에 표시되지 않는 라우트
export const ClassExtra: ISubMenu[] = [];

// Payment routes
export const PaymentRoutes: ISubMenu[] = [
  {
    path: "/payments",
    title: "카리페이 결제",
    exact: true,
    private: false,
    component: withSuspense(BillConfirmPage),
  },
  {
    path: "/payments/process",
    title: "결제 진행",
    exact: true,
    private: false,
    component: withSuspense(PaymentProcessPage),
  },
  {
    path: "/payments/pending",
    title: "결제 대기",
    exact: true,
    private: false,
    component: withSuspense(PaymentPendingPage),
  },
  {
    path: "/payments/result",
    title: "결제 완료",
    exact: true,
    private: false,
    component: withSuspense(PaymentResultPage),
  },
  {
    path: "/payments/error",
    title: "결제 실패",
    exact: true,
    private: false,
    component: withSuspense(PaymentFailPage),
  },

  {
    path: "/test/payTestRequest",
    title: "결제요청 테스트페이지",
    exact: true,
    private: false,
    component: withSuspense(PayTestPage),
  },

  {
    path: "/test/payTestDirect",
    title: "결제요청 테스트페이지",
    exact: true,
    private: false,
    component: withSuspense(PayTestPageDirect),
  },
  {
    path: "/test/payTestResult",
    title: "결제완료 테스트페이지",
    exact: true,
    private: false,
    component: withSuspense(PayTestResultPage),
  },
  {
    path: "/test/payTestCancel",
    title: "결제취소 테스트페이지",
    exact: true,
    private: false,
    component: withSuspense(PayTestCancelPage),
  },
  {
    path: "/test/payTestCancelCari",
    title: "결제취소 테스트페이지",
    exact: true,
    private: false,
    component: withSuspense(payTestCancelCari),
  },
  {
    path: "/test/payTestSearch",
    title: "결제조회 테스트페이지",
    exact: true,
    private: false,
    component: withSuspense(PayTestSearchPage),
  },

  
];

// ClassMenu: 학생/기관 전용 사이드바 메뉴 구성
export const ClassMenu: IMenu[] = [];

// CorpMenu: 기관용 사이드바 메뉴 구성
export const CorpMenu: IMenu[] = [];

// CorpExtra: 관리자용 로그인 등 메뉴에 없는 라우트들
export const CorpExtra: ISubMenu[] = [];
